<template>
  <div class="currentList">
    <div class="currentList_header">
      <div class="currentList_header_left" @click="$router.push({ path: '/multiomics' })">
        <i class="iconfont iconfanhui"></i>
        <p>返回</p>
      </div>
    </div>
    <div class="currentList_listBox">
      <div class="currentList_listBox_list" v-for="(item, index) in data" :key="index" @click="$router.push({path: '/currentSubject?did=' + item.did})">
        <div class="currentList_listBox_list_top">
          <div class="currentList_listBox_list_left">
            <img :src="item.url" alt="">
          </div>
          <div class="currentList_listBox_list_right">
            <p class="currentList_listBox_list_title">{{ item.disease_name }}</p>
            <p class="currentList_listBox_list_message">{{ item.disease_brief }}</p>
          </div>
        </div>
        <p class="currentList_listBox_list_a">立即测试 >></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'currentList',
  data () {
    return {
      data: []
    }
  },
  methods: {
    getDiseaseList () {
      this.util.get(this.api.current_disease_list, '', (success) => {
        this.data = success
      })
    }
  },
  mounted () {
    this.getDiseaseList()
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";

  .currentList {

    .currentList_header {
      width: 100%;
      height: pxToRem(447px);
      background: url("../../assets/images/current/currentList-2.png");
      background-size: cover;
      background-position: center;
      margin-bottom: pxToRem(30px);

      .currentList_header_left {
        display: flex;
        padding-left: pxToRem(10px);
        width: pxToRem(120px);
        height: pxToRem(88px);
        line-height: pxToRem(88px);
        color: #fff;
      }
    }

    .currentList_listBox {
      padding: pxToRem(10px) pxToRem(30px);

      .currentList_listBox_list {
        width: 100%;
        padding: pxToRem(40px) pxToRem(20px);
        background-color: #fff;
        border-radius: pxToRem(30px);
        margin-bottom: pxToRem(20px);

        .currentList_listBox_list_top {
          display: flex;
          align-items: center;

          .currentList_listBox_list_left {
            margin-right: pxToRem(20px);

            img {
              width: pxToRem(190px);
            }
          }

          .currentList_listBox_list_right {

            .currentList_listBox_list_title {
              font-size: pxToRem(35px);
              color: #000;
              margin-bottom: pxToRem(15px);
            }

            .currentList_listBox_list_message {
              font-size: pxToRem(25px);
              text-align: justify;
              color: #595757;
            }
          }
        }

        .currentList_listBox_list_a {
          font-size: pxToRem(20px);
          text-align: right;
          color: #0586C0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/current/currentList.vue